module.exports = __webpack_public_path__ + "img/equipment_2.475efc0f.svg";